// extracted by mini-css-extract-plugin
export var divider = "_re-0";
export var systemMessage = "_re-1";